import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import FeatureDisplay from "../../components/common/FeatureDisplay";
import RequestDemo from "../../components/common/RequestDemo";
import { corporateManagementFeature, corporateManagementFeatures, corporateManagementInfo } from "./solutionConstants";
import ProblemSolved from "../../components/sections/corporateManagement/ProblemSolved";
import corporateManagementAnimation from '../../website animations/Corporate Page animation (1).json'

const CorporateManagementPage = () => {
  return (
    <div id="solution" className="flex flex-col items-center justify-center gap-8 sm:gap-16">
      <HeroReuse
        Subtitle="SOLUTIONS"
        Title="Corporate Management"
        Description="Automate your companies corporate data across all departments."
        // ButtonText="Request a Demo Today"
        lottie={corporateManagementAnimation}
      />
      <FeatureDisplay infoSectionData={corporateManagementInfo} data={corporateManagementFeature} />
      <ProblemSolved features={corporateManagementFeatures} />
      <RequestDemo 
       title={'Learn More About Corporate Management'} />
    </div>
  );
};

export default CorporateManagementPage;
